import { HistoryMessage, MessageModel } from 'types/chat/messages/message';
import { getWhatsappMessageIdFromPayload } from 'utils/normalize-chat-message-payload';

/**
 * API/socket sometimes use `id`, our models use `Id` — same numeric DB id for replies & DOM rows.
 */
export function resolveMessageNumericId(
  msg: HistoryMessage | MessageModel | null | undefined,
): number | null {
  if (!msg) return null;
  const r = msg as Record<string, unknown>;
  const n = r.Id ?? r.id;
  if (typeof n === 'number' && Number.isFinite(n)) return n;
  if (typeof n === 'string' && /^\d+$/.test(n)) return Number.parseInt(n, 10);
  return null;
}

/**
 * לשליחת תגובה: השרת / Meta צריכים **wamid** אמיתי, לא מחרוזת שהיא למעשה Id פנימי (רק ספרות).
 * משתמשים באותה לוגיקה כמו ב־`getWhatsappMessageIdFromPayload` — ואם אין wamid — נופלים ל־`Id` מספרי (כמו ב־DEV).
 */
export function resolveReplyTargetIdForOutgoingSend(
  msg: HistoryMessage | MessageModel | null | undefined,
): string | number | null {
  if (!msg) return null;
  const wa = getWhatsappMessageIdFromPayload(msg as Record<string, unknown>);
  if (wa != null && wa.length > 0) return wa;
  return resolveMessageNumericId(msg);
}
